// Types
import { PopoverContainer, type PopoverChildrenProps } from '@/components/base/Popover';

type DatepickerPanelProps = Omit<
    PopoverChildrenProps,
    'setReferenceElement' | 'open' | 'update'
> & {
    className?: string;
    children: React.ReactNode;
};

export function DatepickerPanel({
    setPopperElement,
    styles,
    attributes,
    className,
    children
}: DatepickerPanelProps) {
    return (
        <PopoverContainer
            styles={styles}
            width="w-[300px]"
            className={className}
            attributes={attributes}
            setPopperElement={setPopperElement}>
            {children}
        </PopoverContainer>
    );
}
